import { QueryClient } from '@tanstack/react-query';

// Central TanStack Query client. Tune defaults here instead of per-hook so every
// screen gets the same caching/retry behaviour unless it explicitly opts out.
export const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: 60 * 1000, // data is considered fresh for 1 minute
      gcTime: 5 * 60 * 1000, // unused cache is garbage collected after 5 minutes
      refetchOnWindowFocus: false,
      retry: 1,
    },
    mutations: {
      retry: 0,
    },
  },
});

export default queryClient;
